var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSchool = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 42"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "school_svg__a",
  width: 42,
  height: 42,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M.328.334h41.6v41.6H.328z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#school_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.13 36.735 8.995 30.148v-10.4l-6.933-3.813 19.066-10.4 19.067 10.4v13.867h-3.467v-11.96l-3.466 1.907v10.4zm0-14.386 11.872-6.414L21.13 9.522 9.256 15.935zm0 10.443 8.666-4.68v-6.543l-8.667 4.766-8.667-4.767v6.544z"
}))));
export default SvgSchool;